import 'url-search-params-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router, { nextRouteMap } from './router'
import store from './store'
import './plugins/pp-vue-library'
import breakpoints from '@/styles/breakpoints.scss'
import PpVueAnalytics from 'pp-vue-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { getBookConfig } from '@/utils/bookConfig'
import trackEventMixin from '@/mixins/trackEventMixin'

Vue.config.productionTip = false

Vue.prototype.$ppUi = {
  isMobile: window.innerWidth < breakpoints.xs
}

Vue.prototype.$nextPage = function () {
  const nextRoute = nextRouteMap[this.$route.name]
  nextRoute && this.$router.push(nextRoute)
}

const params = getBookConfig()
const urlBasedFrame = params.get('urlBasedFrame') !== undefined ? params.get('urlBasedFrame') : 1
Vue.prototype.$urlBasedFrame = Boolean(+urlBasedFrame)
Vue.prototype.$originHost = params.get('originHost')
Vue.prototype.$practiceId = params.get('practiceId')
Vue.prototype.$gaId = params.get('gaId')
Vue.prototype.$useWidgetManager = params.get('useWidgetManager')
Vue.prototype.$locationIdFilter = params.get('locationId') ? +params.get('locationId') : null
Vue.prototype.$providerIdFilter = params.get('providerId') ? +params.get('providerId') : null
Vue.prototype.$appointmentTypeIdFilter = params.get('appointmentTypeId') ? params.get('appointmentTypeId') : null
Vue.prototype.$widgetOrigin = params.get('origin') ? params.get('origin') : null

Vue.prototype.$vuetify = {
  rtl: false,
  lang: {
    t: (val) => val
  },
  theme: {
    dark: false
  },
  icons: {}
}

const env = window.Cypress ? window.Cypress.env() : process.env

const practiceGaId = params.get('gaId')
const appGaId = env.VUE_APP_GA4_ID

if (appGaId) {
  Vue.use(PpVueAnalytics, router, {
    appGaId,
    practiceGaId,
    category: 'bookonline',
    clientGaId: params.get('gaClientId') || '',
    gacId: params.get('gacId') || '',
    gacGbId: params.get('gacGbId') || '',
    trackEventPrefix: 'book_online',
    practiceUuid: params.get('practiceUuid') || '',
    debug: process.env.VUE_APP_STAGE !== 'prd'
  })
}

Vue.mixin(trackEventMixin)

datadogRum.init({
  applicationId: 'd0ce3ae6-3a13-4a63-a19c-37b47558ddc0',
  clientToken: 'pubc0d0759bc8eccfbf15897a3c24441eaf',
  env: process.env.VUE_APP_STAGE,
  version: process.env.VUE_APP_VERSION,
  sessionSampleRate: 50,
  sessionReplaySampleRate: 100,
  site: 'us5.datadoghq.com',
  service: 'book-online-ui',
  usePartitionedCrossSiteSessionCookie: true,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  trackBfcacheViews: true,
  defaultPrivacyLevel: 'mask-user-input',
  beforeSend: (event, context) => {
    if (event.type === 'resource' && event.resource.type === 'fetch') {
      event.context = { ...event.context, responseHeaders: context.response.headers }
    }
  }
})

datadogRum.setGlobalContextProperty('practiceUuid', params.get('practiceUuid'))

const Instance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Instance.$router.push({ name: 'stepA' })
